import { render, staticRenderFns } from "./MobileAppPromptModal.vue?vue&type=template&id=534c5d6a&scoped=true&"
import script from "./MobileAppPromptModal.vue?vue&type=script&lang=js&"
export * from "./MobileAppPromptModal.vue?vue&type=script&lang=js&"
import style0 from "./MobileAppPromptModal.vue?vue&type=style&index=0&id=534c5d6a&scoped=true&lang=scss&"
import style1 from "./MobileAppPromptModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534c5d6a",
  null
  
)

export default component.exports